import React, {useState, useEffect, memo} from "react";
import { useSelector } from "react-redux";
import Header from "./Includes/Header"
import DashboardHeader from "./Includes/DashboardHeader";
import AdminHeader from "./Includes/AdminHeader";
import Footer from "./Includes/Footer"

const PrivacyPolicy = () => {
    const [header, setHeader] = useState("guest");
    const { auth } = useSelector((state) => state);
	useEffect(() => {
		if(auth.data){
			let response=auth.data;
			if(response.status==1){
				if(response.user.role!=1){
					setHeader("dashboard");
				}
				else{
					setHeader("admin");
				}
			}
			else{
				setHeader("guest");
			}
		}
	}, [auth]);
    return (
        <div>
            {
				(header==="guest")?<Header/>:(header==="dashboard")?<DashboardHeader/>:<AdminHeader/>
			}
            <div className="main_content">
                <div className="container_cust legal-page">
                    <div className="legal-header">
                        <h1 className="title-main">Privacy Policy</h1>
                        <p className="legal-meta">Effective Date: 24 Mar 2026 &nbsp;|&nbsp; Last Updated: 24 Mar 2026</p>
                    </div>

                    <section className="legal-section">
                        <h2>1. Introduction</h2>
                        <p>Treasury Technology Company ("Treasury", "we", "us", or "our") is committed to protecting your personal data. This Privacy Policy explains how we collect, use, store, share, and protect your personal information when you use the Treasury platform at platform.treasury.sa ("Platform").</p>
                        <p>This Policy is issued in compliance with the Personal Data Protection Law (PDPL) of the Kingdom of Saudi Arabia and its implementing regulations. By using the Platform, you consent to the practices described in this Policy.</p>
                    </section>

                    <section className="legal-section">
                        <h2>2. Data We Collect</h2>
                        <p>We collect the following categories of personal data:</p>
                        <div className="legal-table-wrap">
                            <table className="legal-table">
                                <thead>
                                    <tr><th>Category</th><th>Examples</th></tr>
                                </thead>
                                <tbody>
                                    <tr><td><strong>Identity Data</strong></td><td>Full name, national ID number, date of birth, nationality</td></tr>
                                    <tr><td><strong>Contact Data</strong></td><td>Email address, phone number, residential address</td></tr>
                                    <tr><td><strong>KYC / Verification Data</strong></td><td>Nafath-verified identity information, biometric data processed by Nafath</td></tr>
                                    <tr><td><strong>Financial Data</strong></td><td>Bank account details, wallet balance, transaction history, investment records</td></tr>
                                    <tr><td><strong>Technical Data</strong></td><td>IP address, browser type, device information, cookies, access logs</td></tr>
                                    <tr><td><strong>Usage Data</strong></td><td>Pages visited, features used, time spent on the Platform</td></tr>
                                    <tr><td><strong>Communications Data</strong></td><td>Messages sent to our support team, feedback submitted</td></tr>
                                </tbody>
                            </table>
                        </div>
                    </section>

                    <section className="legal-section">
                        <h2>3. How We Collect Your Data</h2>
                        <p>We collect personal data through the following means:</p>
                        <ul>
                            <li><strong>Directly from you</strong> when you register, complete KYC, make investments, or contact us;</li>
                            <li><strong>Automatically</strong> through cookies, log files, and analytics tools when you use the Platform;</li>
                            <li><strong>From third parties</strong> including Nafath (identity verification) and the Real Estate Registry (RER) (property and token data).</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>4. How We Use Your Data</h2>
                        <p>We use your personal data for the following purposes:</p>
                        <ul>
                            <li><strong>Account management:</strong> To create, verify, and manage your account;</li>
                            <li><strong>KYC and compliance:</strong> To verify your identity and comply with anti-money laundering (AML) and counter-terrorism financing (CTF) regulations;</li>
                            <li><strong>Investment services:</strong> To process subscriptions, sell orders, distributions, and withdrawals;</li>
                            <li><strong>Communications:</strong> To send transaction confirmations, platform updates, and important notices;</li>
                            <li><strong>Security:</strong> To detect, prevent, and investigate fraud, unauthorised access, and other illegal activities;</li>
                            <li><strong>Legal obligations:</strong> To comply with applicable Saudi laws and regulatory requirements, including requests from competent authorities;</li>
                            <li><strong>Platform improvement:</strong> To analyse usage patterns and improve the Platform's features and performance.</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>5. Legal Basis for Processing</h2>
                        <p>We process your personal data on the following legal bases under the PDPL:</p>
                        <ul>
                            <li><strong>Contractual necessity:</strong> Processing required to perform our agreement with you (e.g., executing investments);</li>
                            <li><strong>Legal obligation:</strong> Processing required to comply with applicable laws and regulations;</li>
                            <li><strong>Legitimate interests:</strong> Processing for fraud prevention, security, and platform improvement;</li>
                            <li><strong>Consent:</strong> Where you have provided explicit consent, which you may withdraw at any time.</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>6. Data Sharing</h2>
                        <p>We do not sell your personal data. We may share your data with:</p>
                        <div className="legal-table-wrap">
                            <table className="legal-table">
                                <thead>
                                    <tr><th>Recipient</th><th>Purpose</th></tr>
                                </thead>
                                <tbody>
                                    <tr><td><strong>Nafath</strong></td><td>Identity verification and KYC</td></tr>
                                    <tr><td><strong>Real Estate Registry (RER)</strong></td><td>Token registration and property data</td></tr>
                                    <tr><td><strong>Payment processors</strong></td><td>Processing deposits and withdrawals</td></tr>
                                    <tr><td><strong>Cloud service providers</strong></td><td>Secure data hosting and infrastructure</td></tr>
                                    <tr><td><strong>Regulatory authorities</strong></td><td>Compliance with legal obligations</td></tr>
                                    <tr><td><strong>Professional advisors</strong></td><td>Legal, audit, and compliance services</td></tr>
                                </tbody>
                            </table>
                        </div>
                        <p>All third parties are required to process your data in accordance with applicable law and our data processing agreements.</p>
                    </section>

                    <section className="legal-section">
                        <h2>7. Data Retention</h2>
                        <p>We retain your personal data for as long as necessary to fulfil the purposes described in this Policy, and in accordance with applicable legal and regulatory retention requirements:</p>
                        <ul>
                            <li><strong>Account and transaction data:</strong> Retained for a minimum of 10 years following account closure, as required by Saudi financial regulations;</li>
                            <li><strong>KYC data:</strong> Retained for the duration required by AML/CTF regulations;</li>
                            <li><strong>Technical and usage data:</strong> Retained for up to 12 months.</li>
                        </ul>
                        <p>Upon expiry of the applicable retention period, data is securely deleted or anonymised.</p>
                    </section>

                    <section className="legal-section">
                        <h2>8. Data Security</h2>
                        <p>Treasury implements appropriate technical and organisational measures to protect your personal data against unauthorised access, disclosure, alteration, or destruction. These measures include:</p>
                        <ul>
                            <li>Encryption of data in transit (TLS/HTTPS) and at rest;</li>
                            <li>Access controls and role-based permissions;</li>
                            <li>Regular security assessments and monitoring;</li>
                            <li>Secure data centres with physical access controls.</li>
                        </ul>
                        <p>However, no method of transmission over the internet is completely secure. You are responsible for maintaining the confidentiality of your account credentials.</p>
                    </section>

                    <section className="legal-section">
                        <h2>9. Cookies</h2>
                        <p>The Platform uses cookies and similar tracking technologies to enhance your experience. You may control cookie settings through your browser; however, disabling certain cookies may affect Platform functionality.</p>
                    </section>

                    <section className="legal-section">
                        <h2>10. Your Rights</h2>
                        <p>Under the PDPL, you have the following rights regarding your personal data:</p>
                        <ul>
                            <li><strong>Right of access:</strong> To request a copy of the personal data we hold about you;</li>
                            <li><strong>Right to correction:</strong> To request correction of inaccurate or incomplete data;</li>
                            <li><strong>Right to erasure:</strong> To request deletion of your data, subject to legal retention obligations;</li>
                            <li><strong>Right to restrict processing:</strong> To request that we limit how we use your data in certain circumstances;</li>
                            <li><strong>Right to data portability:</strong> To receive your data in a structured, machine-readable format;</li>
                            <li><strong>Right to withdraw consent:</strong> To withdraw consent at any time where processing is based on consent.</li>
                        </ul>
                        <p>To exercise any of these rights, please contact us at partnerships@treasury.sa. We will respond within 30 days.</p>
                    </section>

                    <section className="legal-section">
                        <h2>11. Children's Privacy</h2>
                        <p>The Platform is not intended for use by individuals under the age of 18. We do not knowingly collect personal data from minors. If we become aware that a minor has provided personal data, we will take steps to delete such data promptly.</p>
                    </section>

                    <section className="legal-section">
                        <h2>12. International Data Transfers</h2>
                        <p>Your personal data is stored and processed within the Kingdom of Saudi Arabia. Where data is transferred outside the Kingdom, we ensure appropriate safeguards are in place in accordance with the PDPL and applicable regulations.</p>
                    </section>

                    <section className="legal-section">
                        <h2>13. Changes to This Policy</h2>
                        <p>We may update this Privacy Policy from time to time. We will notify you of material changes by posting the updated Policy on the Platform and updating the "Last Updated" date. Your continued use of the Platform following any update constitutes acceptance of the revised Policy.</p>
                    </section>

                    <section className="legal-section legal-contact">
                        <h2>14. Contact</h2>
                        <p>For any questions, concerns, or requests regarding this Privacy Policy, please contact our Data Protection Officer at:</p>
                        <p>
                            <strong>Treasury Technology Company</strong><br/>
                            7076 Al Sahaba Rd., Ishbiliyah 13225, Riyadh, Saudi Arabia<br/>
                            Email: <a href="mailto:partnerships@treasury.sa">partnerships@treasury.sa</a><br/>
                            Platform: <a href="https://platform.treasury.sa">platform.treasury.sa</a>
                        </p>
                    </section>
                </div>
            </div>    
            <Footer />
        </div>
    );
};

export default memo(PrivacyPolicy);
